import { Component, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, Validator, ValidationErrors, ReactiveFormsModule } from '@angular/forms';
import { CustomValidators } from '../../validators/custom-validators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, NgIf } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { provideAnimations } from '@angular/platform-browser/animations';

@Component({
  selector: 'app-nro-processo-input',
  templateUrl: './nro-processo-input.component.html',
  styleUrls: ['./nro-processo-input.component.css'],
  providers: [
    provideNgxMask(),
    provideAnimations(),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NroProcessoInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NroProcessoInputComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaskDirective
  ]
})
export class NroProcessoInputComponent implements ControlValueAccessor, Validator {

  @Input() tipoOrdem: string;

  control = new UntypedFormControl('', [
    CustomValidators.validatorNroProcesso
  ]);

  onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.control.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  validate(control: UntypedFormControl): ValidationErrors | null {
    return this.control.errors;
  }
}
